export const CLIENT_PUBLISHER_URL = '/main/publishers/';

export const CLIENT_CHRONICLE_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=chronicle`;
export const CLIENT_CHRONICLE_YEAR_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=special_project_chronicles_year`;
export const CLIENT_ONE_LINE_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=one_line`;
export const CLIENT_NEWS_FEED_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=feed`;
export const CLIENT_COMPANIES_FEED_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=feed_company`;
export const CLIENT_MAIN_NEWS_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=main_news`;
export const CLIENT_VIDEO_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=video`;
export const CLIENT_EXPERTS_OPINIONS_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=expert_opinions`;
export const CLIENT_SPECIAL_PROJECT_CHRONICLES_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=special_project_chronicles`;
export const CLIENT_RETAIL_MAGAZINE_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=retail_magazine`;
export const CLIENT_WAREHOUSE_MAGAZINE_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=warehouse_magazine`;
export const CLIENT_STORIES_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=stories`;
export const CLIENT_PHOTOS_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=photos`;
export const CLIENT_FEED_SPECIAL_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=special_project_feed`;

// Publishers of the /journal section. retail_magazine (events) and
// warehouse_magazine (news) above look similar but are main-page blocks
export const CLIENT_JOURNAL_RECOMMENDED_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=journal_recommended`;
export const CLIENT_JOURNAL_ADVERTISING_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=journal_advertising`;

export const CLIENT_CHRONICLE_PREVIEW_URL = `/main/preview/chronicle/by_hash/`;
export const CLIENT_FEED_SPECIAL_PREVIEW_URL = `/main/preview/special_project_feed/by_hash/`;
export const CLIENT_PUBLISHER_SPECIAL_YEAR_URL = `${CLIENT_PUBLISHER_URL}special-project-year/`;
export const CLIENT_EVENTS_MAIN_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=events-main`;
export const CLIENT_EVENTS_AFFICHE_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=events-affiche`;
export const CLIENT_EVENTS_PARTNERS_URL = `${CLIENT_PUBLISHER_URL}?type_publisher=events-partners`;

export const CLIENT_CHRONICLE_KEY = `client_publisher_chronicle`;
export const CLIENT_CHRONICLE_YEAR_KEY = `client_publisher_chronicle_year`;
export const CLIENT_CHRONICLE_PREVIEW_KEY = `client_publisher_chronicle_preview`;
export const CLIENT_NEWS_FEED_KEY = `client_publisher_feed`;
export const CLIENT_COMPANIES_FEED_KEY = `client_publisher_feed_company`;
export const CLIENT_MAIN_NEWS_KEY = `client_publisher_main_news`;
export const CLIENT_PUBLISHER_SPECIAL_YEAR_KEY = `client_publisher_special_year_key`;
export const CLIENT_FEED_SPECIAL_KEY = 'client_publisher_feed_special';
export const CLIENT_FEED_SPECIAL_PREVIEW_KEY =
  'client_publisher_feed_special_preview';
export const CLIENT_EVENTS_MAIN_KEY = 'client_publisher_events_main';
export const CLIENT_EVENTS_AFFICHE_KEY = 'client_publisher_events_affiche';
export const CLIENT_EVENTS_PARTNERS_KEY = 'client_publisher_events_partners';
export const CLIENT_JOURNAL_RECOMMENDED_KEY =
  'client_publisher_journal_recommended';
export const CLIENT_JOURNAL_ADVERTISING_KEY =
  'client_publisher_journal_advertising';
